// src/App.jsx
// ─────────────────────────────────────────────────────────────
// الإضافات الجديدة مميزة بـ ← NEW
// ─────────────────────────────────────────────────────────────
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Auth
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import BroadcastsPage from "./pages/broadcasts/BroadcastsPage";
// Dashboard
import Dashboard from "./pages/dashboard/Dashboard";
import DashboardLayout from "./components/DashboardLayout";

// Teachers
import TeachersList from "./pages/teachers/TeachersList";

// ← NEW: Programs & Subscriptions
import ProgramsList from "./pages/teachers/ProgramsList";
import SubscriptionsList from "./pages/teachers/SubscriptionsList";

// Placement Test Routes
import QuestionBanksList from "./pages/placement/QuestionBanksList";
import CreateQuestionBank from "./pages/placement/CreateQuestionBank";
import QuestionBankDetails from "./pages/placement/Questionbankdetail";
import AddVocabularyQuestion from "./pages/placement/Addvocabularyquestion";
import AddGrammarQuestion from "./pages/placement/Addgrammarquestion";
import AddReadingQuestion from "./pages/placement/Addreadingquestion";
import AddListeningQuestion from "./pages/placement/AddListeningQuestion";
import AddSpeakingQuestion from "./pages/placement/AddSpeakingQuestion";
import AddWritingQuestion from "./pages/placement/Addwritingquestion";

// Levels System Routes
import LevelsList from "./pages/levels/Levelslist";
import CreateLevel from "./pages/levels/Createlevel";
import LevelDetails from "./pages/levels/Leveldetails";
import EditLevel from "./pages/levels/Editlevel";

// Units Routes
import UnitsList from "./pages/levels/UnitsList";
import CreateUnit from "./pages/levels/CreateUnit";
import UnitDetails from "./pages/levels/UnitDetails";
import EditUnit from "./pages/levels/EditUnit";
import AddLessonContent from "./pages/levels/AddLessonContent";

// Lessons Routes
import LessonsList from "./pages/levels/LessonsList";
import CreateLesson from "./pages/levels/CreateLesson";
import LessonDetails from "./pages/levels/Lessondetails";
import EditLesson from "./pages/levels/Editlesson";

// Level Question Banks Routes
import LevelQuestionBanksList from "./pages/levels/Levelquestionbankslist";
import LevelQuestionBankDetails from "./pages/levels/Levelquestionbankdetails";
import AddLevelVocabularyQuestion from "./pages/levels/Addlevelvocabularyquestion";
import AddLevelGrammarQuestion from "./pages/levels/Addlevelgrammarquestion";
import AddLevelReadingQuestion from "./pages/levels/AddLevelReadingQuestion";
import AddLevelListeningQuestion from "./pages/levels/AddLevelListeningQuestion";
import AddLevelSpeakingQuestion from "./pages/levels/AddLevelSpeakingQuestion";
import AddLevelWritingQuestion from "./pages/levels/AddLevelWritingQuestion";
import LanguageAIGeneration from "./pages/languages/LanguageAIGeneration";

// IELTS Routes
import IELTSMain from "./pages/ielts/IELTSMain";
import IELTSSkillsList from "./pages/ielts/IELTSSkillsList";
import CreateIELTSSkill from "./pages/ielts/CreateIELTSSkill";
import EditIELTSSkill from "./pages/ielts/EditIELTSSkill";
import IELTSSkillDetails from "./pages/ielts/IELTSSkillDetails";
import AddVocabularyToIELTS from "./pages/ielts/AddVocabularyToIELTS";
import AddGrammarToIELTS from "./pages/ielts/AddGrammarToIELTS";
import AddReadingPassageToIELTS from "./pages/ielts/AddReadingPassageToIELTS";
import AddReadingQuestionsToIELTS from "./pages/ielts/AddReadingQuestionsToIELTS";
import AddListeningAudioToIELTS from "./pages/ielts/AddListeningAudioToIELTS";
import AddListeningQuestionsToIELTS from "./pages/ielts/AddListeningQuestionsToIELTS";
import AddSpeakingVideoToIELTS from "./pages/ielts/AddSpeakingVideoToIELTS";
import AddSpeakingQuestionsToIELTS from "./pages/ielts/AddSpeakingQuestionsToIELTS";
import AddWritingToIELTS from "./pages/ielts/AddWritingToIELTS";
import IELTSProgress from "./pages/ielts/IELTSProgress";
import IELTSAIGeneration from "./pages/ielts/IELTSAIGeneration";

// STEP Routes
import STEPMain from "./pages/step/STEPMain";
import STEPSkillsList from "./pages/step/STEPSkillsList";
import CreateSTEPSkill from "./pages/step/CreateSTEPSkill";
import EditSTEPSkill from "./pages/step/EditSTEPSkill";
import STEPSkillDetails from "./pages/step/STEPSkillDetails";
import AddVocabularyToSTEP from "./pages/step/AddVocabularyToSTEP";
import AddGrammarToSTEP from "./pages/step/AddGrammarToSTEP";
import AddReadingPassageToSTEP from "./pages/step/AddReadingPassageToSTEP";
import AddReadingQuestionsToSTEP from "./pages/step/AddReadingQuestionsToSTEP";
import AddListeningAudioToSTEP from "./pages/step/AddListeningAudioToSTEP";
import AddListeningQuestionsToSTEP from "./pages/step/AddListeningQuestionsToSTEP";
import AddSpeakingVideoToSTEP from "./pages/step/AddSpeakingVideoToSTEP";
import AddSpeakingQuestionsToSTEP from "./pages/step/AddSpeakingQuestionsToSTEP";
import AddWritingToSTEP from "./pages/step/AddWritingToSTEP";
import STEPProgress from "./pages/step/STEPProgress";
import STEPAIGeneration from "./pages/step/STEPAIGeneration";

// GENERAL ENGLISH Routes
import GeneralMain from "./pages/general/GeneralMain";
import GeneralCategoriesList from "./pages/general/GeneralCategoriesList";
import CreateGeneralCategory from "./pages/general/CreateGeneralCategory";
import GeneralSkillsList from "./pages/general/GeneralSkillsList";
import CreateGeneralSkill from "./pages/general/CreateGeneralSkill";
import GeneralSkillDetails from "./pages/general/GeneralSkillDetails";
import AddMCQToGeneral from "./pages/general/AddMCQToGeneral";
import AddReadingToGeneral from "./pages/general/AddReadingToGeneral";
import AddReadingQuestionsToGeneral from "./pages/general/AddReadingQuestionsToGeneral";
import AddListeningToGeneral from "./pages/general/AddListeningToGeneral";
import AddListeningQuestionsToGeneral from "./pages/general/AddListeningQuestionsToGeneral";
import AddSpeakingToGeneral from "./pages/general/AddSpeakingToGeneral";
import AddSpeakingQuestionsToGeneral from "./pages/general/AddSpeakingQuestionsToGeneral";
import AddWritingToGeneral from "./pages/general/AddWritingToGeneral";
import GeneralAIGeneration from "./pages/general/GeneralAIGeneration";

// ESP ENGLISH Routes
import EspMain from "./pages/esp/EspMain";
import EspCategoriesList from "./pages/esp/EspCategoriesList";
import CreateEspCategory from "./pages/esp/CreateEspCategory";
import EspSkillsList from "./pages/esp/EspSkillsList";
import CreateEspSkill from "./pages/esp/CreateEspSkill";
import EspSkillDetails from "./pages/esp/EspSkillDetails";
import AddMCQToEsp from "./pages/esp/AddMCQToEsp";
import AddReadingToEsp from "./pages/esp/AddReadingToEsp";
import AddReadingQuestionsToEsp from "./pages/esp/AddReadingQuestionsToEsp";
import AddListeningToEsp from "./pages/esp/AddListeningToEsp";
import AddListeningQuestionsToEsp from "./pages/esp/AddListeningQuestionsToEsp";
import AddSpeakingToEsp from "./pages/esp/AddSpeakingToEsp";
import AddSpeakingQuestionsToEsp from "./pages/esp/AddSpeakingQuestionsToEsp";
import AddWritingToEsp from "./pages/esp/AddWritingToEsp";
import EspAIGeneration from "./pages/esp/EspAIGeneration";

import PaymentCallback from "./pages/payment/PaymentCallback";
import PaymentPage from "./pages/payment/PaymentPage";
import ProtectedRoute from "./components/ProtectedRoute";

import StepPaymentCallback from "./pages/payment/StepPaymentCallback";
import StepPaymentPage from "./pages/payment/StepPaymentPage";
import IeltsPaymentCallback from "./pages/payment/IeltsPaymentCallback";
import IeltsPaymentPage from "./pages/payment/IeltsPaymentPage";
import Privacypolicy from "./pages/privacypolicy/Privacypolicy";
import SupportPage from "./pages/support/SupportPage";
import DiscountCodesList from "./pages/discounts/DiscountCodesList";
import STEPPlans from "./pages/step/STEPPlans";
import IELTSPlans from "./pages/ielts/IELTSPlans";
import EspCategoryPlans from "./pages/esp/EspCategoryPlans";
import GeneralCategoryPlans from "./pages/general/GeneralCategoryPlans";
import EspPaymentCallback from "./pages/payment/EspPaymentCallback";
import EspPaymentPage from "./pages/payment/EspPaymentPage";
import GeneralPaymentCallback from "./pages/payment/GeneralPaymentCallback";
import GeneralPaymentPage from "./pages/payment/GeneralPaymentPage";
import BranchSubscribersManager from "./pages/subscriptions/BranchSubscribersManager";

import LanguagesList from "./pages/languages/LanguagesList";
import LanguageCategoriesList from "./pages/languages/LanguageCategoriesList";
import CreateLanguageCategory from "./pages/languages/CreateLanguageCategory";
import LanguageSkillsList from "./pages/languages/LanguageSkillsList";
import CreateLanguageSkill from "./pages/languages/CreateLanguageSkill";
import LanguageSkillDetails from "./pages/languages/LanguageSkillDetails";
import AddMCQToLanguage from "./pages/languages/AddMCQToLanguage";
import LanguageParentContentForm from "./pages/languages/LanguageParentContentForm";
import AddWritingToLanguage from "./pages/languages/AddWritingToLanguage";
import AcademyCategoriesList from "./pages/academy/AcademyCategoriesList";
import CreateAcademyCategory from "./pages/academy/CreateAcademyCategory";
import AcademyExamsList from "./pages/academy/AcademyExamsList";
import CreateAcademyExam from "./pages/academy/CreateAcademyExam";
import AcademySkillsList from "./pages/academy/AcademySkillsList";
import AcademySkillDetail from "./pages/academy/AcademySkillDetail"; 
import CreateAcademySkill from "./pages/academy/CreateAcademySkill";
import AcademicCategoriesList from "./pages/academic/AcademicCategoriesList";
import CreateAcademicCategory from "./pages/academic/CreateAcademicCategory";
import AcademicExamsList from "./pages/academic/AcademicExamsList";
import CreateAcademicExam from "./pages/academic/CreateAcademicExam";
import AcademicSkillsList from "./pages/academic/AcademicSkillsList";
import CreateAcademicSkill from "./pages/academic/CreateAcademicSkill";
import AcademyContentForm from "./pages/academy/AcademyContentForm"; 
import { ACADEMY_ROOT } from "./pages/academy/academyConstants";
import AcademyParentWithQuestionsForm from "./pages/academy/AcademyParentWithQuestionsForm"; 
import AcademyAIGeneration from "./pages/academy/AcademyAIGeneration";
import TeacherPermissions from "./pages/teachers/TeacherPermissions";
import TeacherAccountsList from "./pages/teachers/TeacherAccountsList";
import AcademyCategoryPlans from "./pages/academy/AcademyCategoryPlans";

// ← NEW: Advertisements
import AdvertisementsList from "./pages/advertisements/AdvertisementsList";
// ← NEW: Consultations
import ConsultationsList from "./pages/consultations/ConsultationsList";
import LanguageCategoryPlans from "./pages/languages/LanguageCategoryPlans";

// ← NEW: Student Groups
import GroupsList from "./pages/groups/GroupsList";
import GroupDetails from "./pages/groups/GroupDetails";
import MyStudents from "./pages/groups/MyStudents";
import SpeakingClubsList from "./pages/speaking-clubs/SpeakingClubsList";
import SpeakingClubForm from "./pages/speaking-clubs/SpeakingClubForm";
import SpeakingClubBookings from "./pages/speaking-clubs/SpeakingClubBookings";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/reset-password/:uidb64/:token"
          element={<ResetPassword />}
        />
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
        <Route path="speaking-clubs" element={<SpeakingClubsList />} />
        <Route path="speaking-clubs/create" element={<SpeakingClubForm />} />
        <Route path="speaking-clubs/:clubId/edit" element={<SpeakingClubForm />} />
        <Route path="speaking-clubs/:clubId/bookings" element={<SpeakingClubBookings />} />
          <Route index element={<Dashboard />} />

          {/* ─── TEACHERS ─── */}
          <Route path="teachers" element={<TeachersList />} />
          <Route path="consultations" element={<ConsultationsList />} />
          {/* ─── LANGUAGES SYSTEM ← NEW ─── */}
          <Route path="languages" element={<LanguagesList />} />
          <Route path="languages/:languageId/categories" element={<LanguageCategoriesList />} />
          <Route path="languages/:languageId/categories/create" element={<CreateLanguageCategory />} />
          <Route path="languages/categories/:categoryId/edit" element={<CreateLanguageCategory />} />
          <Route path="languages/categories/:categoryId/skills" element={<LanguageSkillsList />} />
          <Route path="languages/categories/:categoryId/skills/create" element={<CreateLanguageSkill />} />
          <Route path="languages/skills/:skillId" element={<LanguageSkillDetails />} />
          <Route path="languages/skills/:skillId/edit" element={<CreateLanguageSkill />} />
          
          <Route
            path="languages/skills/:skillId/vocabulary/create"
            element={<AddMCQToLanguage questionType="VOCABULARY" />}
          />
          <Route path="languages/categories/:categoryId/plans" element={<LanguageCategoryPlans />} />
          {/* ─── BROADCASTS ← NEW ─── */}
          <Route path="broadcasts" element={<BroadcastsPage />} />
          {/* ← NEW */}
          <Route
            path="languages/skills/:skillId/vocabulary/:questionId/edit"
            element={<AddMCQToLanguage questionType="VOCABULARY" />}
          />
          <Route
            path="languages/skills/:skillId/grammar/create"
            element={<AddMCQToLanguage questionType="GRAMMAR" />}
          />
          {/* ← NEW */}
          <Route
            path="languages/skills/:skillId/grammar/:questionId/edit"
            element={<AddMCQToLanguage questionType="GRAMMAR" />}
          />
          <Route path="languages/skills/:skillId/reading/create"
            element={<LanguageParentContentForm key="READING" kind="READING" />} />
          <Route path="languages/skills/:skillId/reading/:itemId/edit"
            element={<LanguageParentContentForm key="READING" kind="READING" />} />

          <Route path="languages/skills/:skillId/listening/create"
            element={<LanguageParentContentForm key="LISTENING" kind="LISTENING" />} />
          <Route path="languages/skills/:skillId/listening/:itemId/edit"
            element={<LanguageParentContentForm key="LISTENING" kind="LISTENING" />} />

          <Route path="languages/skills/:skillId/speaking/create"
            element={<LanguageParentContentForm key="SPEAKING" kind="SPEAKING" />} />
          <Route path="languages/skills/:skillId/speaking/:itemId/edit"
            element={<LanguageParentContentForm key="SPEAKING" kind="SPEAKING" />} />

          <Route path="languages/skills/:skillId/writing/create" element={<AddWritingToLanguage />} />
          <Route path="languages/skills/:skillId/writing/:itemId/edit" element={<AddWritingToLanguage />} />
          <Route path="/dashboard/languages/:languageId/ai" element={<LanguageAIGeneration />} />
          {/* ─── ACADEMY ─── */}
            <Route path="academy" element={<AcademyCategoriesList />} />
            <Route path="academy/categories/create" element={<CreateAcademyCategory />} />
            <Route path="academy/categories/:categoryId/edit" element={<CreateAcademyCategory />} />
            <Route path="academy/categories/:categoryId/exams" element={<AcademyExamsList />} />
            <Route path="academy/categories/:categoryId/exams/create" element={<CreateAcademyExam />} />
            <Route path="academy/categories/:categoryId/exams/:examId/edit" element={<CreateAcademyExam />} />
            <Route path="academy/exams/:examId/skills" element={<AcademySkillsList />} />
            <Route path="academy/exams/:examId/skills/create" element={<CreateAcademySkill />} />
            <Route path="academy/exams/:examId/skills/:skillId/edit" element={<CreateAcademySkill />} />
            <Route path="academy/skills/:skillId" element={<AcademySkillDetail />} />  
            <Route path="academy/skills/:skillId/questions/:kind/create" element={<AcademyContentForm />} />   
            <Route path="academy/categories/:categoryId/plans" element={<AcademyCategoryPlans />} />
            <Route path="academy/skills/:skillId/questions/:kind/:id/edit" element={<AcademyContentForm />} />
            <Route path={`${ACADEMY_ROOT}/skills/:skillId/:contentType/create`} element={<AcademyParentWithQuestionsForm />}/>
            <Route path="academy/ai" element={<AcademyAIGeneration />} />
            <Route path="teachers/:teacherId/permissions" element={<TeacherPermissions />} />
            <Route path="teacher-accounts" element={<TeacherAccountsList />} />

            {/* ─── ADVERTISEMENTS ← NEW ─── */}
            <Route path="advertisements" element={<AdvertisementsList />} />
            

            {/* ─── ACADEMIC PROGRMS ─── */}
            <Route path="academic" element={<AcademicCategoriesList />} />
            <Route path="academic/categories/create" element={<CreateAcademicCategory />} />
            <Route path="academic/categories/:categoryId/edit" element={<CreateAcademicCategory />} />
            <Route path="academic/categories/:categoryId/exams" element={<AcademicExamsList />} />
            <Route path="academic/categories/:categoryId/exams/create" element={<CreateAcademicExam />} />
            <Route path="academic/categories/:categoryId/exams/:examId/edit" element={<CreateAcademicExam />} />
            <Route path="academic/exams/:examId/skills" element={<AcademicSkillsList />} />
            <Route path="academic/exams/:examId/skills/create" element={<CreateAcademicSkill />} />
            <Route path="academic/exams/:examId/skills/:skillId/edit" element={<CreateAcademicSkill />} />
          
          {/* ─── PROGRAMS ← NEW ─── */}
          <Route path="programs" element={<ProgramsList />} />
          {/* ─── STUDENT GROUPS ← NEW ─── */}
          <Route path="groups" element={<GroupsList />} />
          <Route path="groups/students" element={<MyStudents />} />
          <Route path="groups/:groupId" element={<GroupDetails />} />

          {/* ─── SUBSCRIPTIONS ← NEW ─── */}
          <Route path="subscriptions" element={<SubscriptionsList />} />
          {/* ─── DISCOUNT CODES ← NEW ─── */}
          <Route path="discounts" element={<DiscountCodesList />} />
          <Route path="step/plans" element={<STEPPlans />} />
          <Route path="ielts/plans" element={<IELTSPlans />} />
          {/* ─── SUBSCRIBERS MANAGEMENT (IELTS/STEP/ESP/General) ← NEW ─── */}
          <Route path="subscribers" element={<BranchSubscribersManager />} />
          {/* ─── PLACEMENT TEST ─── */}
          <Route path="question-banks" element={<QuestionBanksList />} />
          <Route
            path="question-banks/create"
            element={<CreateQuestionBank />}
          />
          <Route
            path="question-banks/:bankId"
            element={<QuestionBankDetails />}
          />
          <Route
            path="question-banks/:bankId/add/vocabulary"
            element={<AddVocabularyQuestion />}
          />
          <Route
            path="question-banks/:bankId/add/grammar"
            element={<AddGrammarQuestion />}
          />
          <Route
            path="question-banks/:bankId/add/reading"
            element={<AddReadingQuestion />}
          />
          <Route
            path="question-banks/:bankId/add/listening"
            element={<AddListeningQuestion />}
          />
          <Route
            path="question-banks/:bankId/add/speaking"
            element={<AddSpeakingQuestion />}
          />
          <Route
            path="question-banks/:bankId/add/writing"
            element={<AddWritingQuestion />}
          />

          {/* ─── LEVELS ─── */}
          <Route path="levels" element={<LevelsList />} />
          <Route path="levels/create" element={<CreateLevel />} />
          <Route path="levels/:levelId" element={<LevelDetails />} />
          <Route path="levels/:levelId/edit" element={<EditLevel />} />

          {/* ─── UNITS ─── */}
          <Route path="units" element={<UnitsList />} />
          <Route path="units/create" element={<CreateUnit />} />
          <Route path="units/:unitId" element={<UnitDetails />} />
          <Route path="units/:unitId/edit" element={<EditUnit />} />

          {/* ─── LESSONS ─── */}
          <Route path="lessons" element={<LessonsList />} />
          <Route path="lessons/create" element={<CreateLesson />} />
          <Route path="lessons/:lessonId" element={<LessonDetails />} />
          <Route path="lessons/:lessonId/edit" element={<EditLesson />} />
          <Route
            path="lessons/:lessonId/content/add"
            element={<AddLessonContent />}
          />

          {/* ─── LEVEL QUESTION BANKS ─── */}
          <Route
            path="level-question-banks"
            element={<LevelQuestionBanksList />}
          />
          <Route
            path="level-question-banks/:bankId"
            element={<LevelQuestionBankDetails />}
          />
          <Route
            path="level-question-banks/:bankId/add/vocabulary"
            element={<AddLevelVocabularyQuestion />}
          />
          <Route
            path="level-question-banks/:bankId/add/grammar"
            element={<AddLevelGrammarQuestion />}
          />
          <Route
            path="level-question-banks/:bankId/add/reading"
            element={<AddLevelReadingQuestion />}
          />
          <Route
            path="level-question-banks/:bankId/add/listening"
            element={<AddLevelListeningQuestion />}
          />
          <Route
            path="level-question-banks/:bankId/add/speaking"
            element={<AddLevelSpeakingQuestion />}
          />
          <Route
            path="level-question-banks/:bankId/add/writing"
            element={<AddLevelWritingQuestion />}
          />

          {/* ─── IELTS ─── */}
          <Route path="ielts" element={<IELTSMain />} />
          <Route path="ielts/skills" element={<IELTSSkillsList />} />
          <Route path="ielts/skills/create" element={<CreateIELTSSkill />} />
          <Route path="ielts/skills/:skillId" element={<IELTSSkillDetails />} />
          <Route
            path="ielts/skills/:skillId/edit"
            element={<EditIELTSSkill />}
          />
          <Route
            path="ielts/skills/:skillId/add/vocabulary"
            element={<AddVocabularyToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/grammar"
            element={<AddGrammarToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/reading/passage"
            element={<AddReadingPassageToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/reading/passage/:passageId/questions"
            element={<AddReadingQuestionsToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/listening/audio"
            element={<AddListeningAudioToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/listening/audio/:audioId/questions"
            element={<AddListeningQuestionsToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/speaking/video"
            element={<AddSpeakingVideoToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/speaking/video/:videoId/questions"
            element={<AddSpeakingQuestionsToIELTS />}
          />
          <Route
            path="ielts/skills/:skillId/add/writing"
            element={<AddWritingToIELTS />}
          />
          <Route path="ielts/progress" element={<IELTSProgress />} />
          <Route path="ielts/ai" element={<IELTSAIGeneration />} />

          {/* ─── STEP ─── */}
          <Route path="step" element={<STEPMain />} />
          <Route path="step/skills" element={<STEPSkillsList />} />
          <Route path="step/skills/create" element={<CreateSTEPSkill />} />
          <Route path="step/skills/:skillId" element={<STEPSkillDetails />} />
          <Route path="step/skills/:skillId/edit" element={<EditSTEPSkill />} />
          <Route
            path="step/skills/:skillId/add/vocabulary"
            element={<AddVocabularyToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/grammar"
            element={<AddGrammarToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/reading/passage"
            element={<AddReadingPassageToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/reading/passage/:passageId/questions"
            element={<AddReadingQuestionsToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/listening/audio"
            element={<AddListeningAudioToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/listening/audio/:audioId/questions"
            element={<AddListeningQuestionsToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/speaking/video"
            element={<AddSpeakingVideoToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/speaking/video/:videoId/questions"
            element={<AddSpeakingQuestionsToSTEP />}
          />
          <Route
            path="step/skills/:skillId/add/writing"
            element={<AddWritingToSTEP />}
          />
          <Route path="step/progress" element={<STEPProgress />} />
          <Route path="step/ai" element={<STEPAIGeneration />} />

          {/* ─── GENERAL ENGLISH ─── */}
          <Route path="general" element={<GeneralMain />} />
          <Route
            path="general/categories"
            element={<GeneralCategoriesList />}
          />
          <Route
            path="general/categories/create"
            element={<CreateGeneralCategory />}
          />
          <Route
            path="general/categories/:categoryId/edit"
            element={<CreateGeneralCategory />}
          />
          <Route
              path="general/categories/:categoryId/plans"
              element={<GeneralCategoryPlans />}
            />
          <Route
            path="general/categories/:categoryId/skills"
            element={<GeneralSkillsList />}
          />
          <Route
            path="general/categories/:categoryId/skills/create"
            element={<CreateGeneralSkill />}
          />
          <Route
            path="general/categories/:categoryId/skills/:skillId/edit"
            element={<CreateGeneralSkill />}
          />
          <Route
            path="general/skills/:skillId"
            element={<GeneralSkillDetails />}
          />
          <Route
            path="general/skills/:skillId/add/vocabulary"
            element={<AddMCQToGeneral questionType="VOCABULARY" />}
          />
          <Route
            path="general/skills/:skillId/add/grammar"
            element={<AddMCQToGeneral questionType="GRAMMAR" />}
          />
          <Route
            path="general/skills/:skillId/add/reading/passage"
            element={<AddReadingToGeneral />}
          />
          <Route
            path="general/skills/:skillId/add/reading/passage/:passageId/questions"
            element={<AddReadingQuestionsToGeneral />}
          />
          <Route
            path="general/skills/:skillId/add/listening/audio"
            element={<AddListeningToGeneral />}
          />
          <Route
            path="general/skills/:skillId/add/listening/audio/:audioId/questions"
            element={<AddListeningQuestionsToGeneral />}
          />
          <Route
            path="general/skills/:skillId/add/speaking/video"
            element={<AddSpeakingToGeneral />}
          />
          <Route
            path="general/skills/:skillId/add/speaking/video/:videoId/questions"
            element={<AddSpeakingQuestionsToGeneral />}
          />
          <Route
            path="general/skills/:skillId/add/writing"
            element={<AddWritingToGeneral />}
          />
          <Route path="general/ai" element={<GeneralAIGeneration />} />

          {/* ─── ESP ENGLISH ─── */}
          <Route path="esp" element={<EspMain />} />
          <Route path="esp/categories" element={<EspCategoriesList />} />
          <Route path="esp/categories/create" element={<CreateEspCategory />} />
          <Route
            path="esp/categories/:categoryId/edit"
            element={<CreateEspCategory />}
          />
          <Route
            path="esp/categories/:categoryId/skills"
            element={<EspSkillsList />}
          />
          <Route
            path="esp/categories/:categoryId/plans"
            element={<EspCategoryPlans />}
          />
          <Route
            path="esp/categories/:categoryId/skills/create"
            element={<CreateEspSkill />}
          />
          <Route
            path="esp/categories/:categoryId/skills/:skillId/edit"
            element={<CreateEspSkill />}
          />
          <Route path="esp/skills/:skillId" element={<EspSkillDetails />} />
          <Route
            path="esp/skills/:skillId/add/vocabulary"
            element={<AddMCQToEsp questionType="VOCABULARY" />}
          />
          <Route
            path="esp/skills/:skillId/add/grammar"
            element={<AddMCQToEsp questionType="GRAMMAR" />}
          />
          <Route
            path="esp/skills/:skillId/add/reading/passage"
            element={<AddReadingToEsp />}
          />
          <Route
            path="esp/skills/:skillId/add/reading/passage/:passageId/questions"
            element={<AddReadingQuestionsToEsp />}
          />
          <Route
            path="esp/skills/:skillId/add/listening/audio"
            element={<AddListeningToEsp />}
          />
          <Route
            path="esp/skills/:skillId/add/listening/audio/:audioId/questions"
            element={<AddListeningQuestionsToEsp />}
          />
          <Route
            path="esp/skills/:skillId/add/speaking/video"
            element={<AddSpeakingToEsp />}
          />
          <Route
            path="esp/skills/:skillId/add/speaking/video/:videoId/questions"
            element={<AddSpeakingQuestionsToEsp />}
          />
          <Route
            path="esp/skills/:skillId/add/writing"
            element={<AddWritingToEsp />}
          />
          <Route path="esp/ai" element={<EspAIGeneration />} />
        </Route>
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment/callback" element={<PaymentCallback />} />
        <Route
          path="/step/payment/callback"
          element={<StepPaymentCallback />}
        />
        <Route path="/step/payment" element={<StepPaymentPage />} />
        <Route
          path="/ielts/payment/callback"
          element={<IeltsPaymentCallback />}
        />
        <Route path="/esp/payment/callback" element={<EspPaymentCallback />} />
        <Route path="/esp/payment" element={<EspPaymentPage />} />
        <Route path="/general/payment/callback" element={<GeneralPaymentCallback />} />
        <Route path="/general/payment" element={<GeneralPaymentPage />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route path="/supportpage" element={<SupportPage />} />

        <Route path="/ielts/payment" element={<IeltsPaymentPage />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;